<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Gestion des clients</h2>
    <p class="page-subtitle">Liste de tous vos clients</p>
  </div>
  <a routerLink="/clients/new" class="btn btn-primary btn-with-icon">
    <mat-icon aria-hidden="true">add</mat-icon>
    Nouveau client
  </a>
</div>

<div class="card shadow-sm mb-4">
  <div class="search-bar">
    <div class="search-bar-content">
      <div class="search-input-wrapper">
        <mat-icon class="search-icon" aria-hidden="true">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (input)="onSearchChange(searchQuery)"
          placeholder="Rechercher un client..."
          class="search-input"
        >
      </div>
      <div class="archived-toggle">
        <label class="checkbox-container">
          <input type="checkbox" [checked]="showArchived()" (change)="onToggleArchived()">
          <span class="checkmark"></span>
          Afficher les archivés
        </label>
      </div>
    </div>
  </div>

  <div class="table-responsive">
    <table class="modern-table" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortField">
      <thead>
      <tr>
        <th>Photo</th>
        <th mat-sort-header="numeroClient">N° Client</th>
        <th mat-sort-header="siret">SIRET</th>
        <th mat-sort-header="denomination">Dénomination</th>
        <th>Adresse de facturation</th>
        <th mat-sort-header="ville">Ville</th>
        <th mat-sort-header="codePostal">Code Postal</th>
      </tr>
      </thead>
      <tbody>
        @for (client of clients(); track client.id) {
          <tr (click)="onRowClick(client)" class="clickable-row" [class.archived-row]="client.archived">
            <td>
              <div class="client-photo-wrapper">
                @if (client.id) {
                  <img [attr.src]="getPhotoUrl(client.id)"
                       alt="Photo"
                       class="client-photo-small"
                       #img
                       (error)="img.style.display='none'; icon.style.display='flex'">
                  <div #icon class="client-photo-placeholder" style="display: none;">
                    <mat-icon aria-hidden="true">business</mat-icon>
                  </div>
                }
              </div>
            </td>
            <td>{{ client.numeroClient }}</td>
            <td>{{ client.siret }}</td>
            <td>
              {{ client.denomination }}
              @if (client.archived) {
                <span class="badge-archived">Archivé</span>
              }
            </td>
            <td>{{ client.adresseFacturation }}</td>
            <td>{{ client.ville }}</td>
            <td>{{ client.codePostal }}</td>
          </tr>
        } @empty {
          <tr class="empty-row">
            <td colspan="7">
              <div class="empty-state">
                <mat-icon class="empty-icon" aria-hidden="true">inbox</mat-icon>
                <p>Aucun client trouvé</p>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <mat-paginator [length]="totalElements()"
                 [pageSize]="size()"
                 [pageSizeOptions]="[5, 10, 25, 100]"
                 (page)="onPageChange($event)"
                 aria-label="Sélectionner la page">
  </mat-paginator>
</div>

@if (showDeleteModal()) {
  <app-confirm-dialog
    title="Supprimer le client"
    [message]="'Êtes-vous sûr de vouloir supprimer le client ' + clientToDelete()?.denomination + ' ?'"
    (confirmed)="confirmDelete()"
    (cancelled)="cancelDelete()">
  </app-confirm-dialog>
}
